import angular from 'angular';
import constants from 'app/constants';
import {
  praDataService,
  loaderService,
  ssDialogService,
  userService,
  praSharedModelService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './completed-assessment.controller';
import directive from './completed-assessment.directive';


export default angular.module('app.components.advisory.pra.completedAssessment', [
  alerts,
  praDataService,
  confirmDialog,
  constants,
  loaderService,
  ssDialogService,
  userService,
  praSharedModelService
])
  .directive('praCompletedAssessment', directive)
  .controller('PRACompletedAssessmentController', controller)
  .name;

console.log('app.components.advisory.pra.completedAssessment created');
